<div class="row mb-4">
    <div class="col-sm-12 mx-auto">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <h4 class="card-title col-12 mb-4">Edit Admin</h4>
                    <div class="text-center" *ngIf="!formGroup?.controls?.id">
                        <div class="spinner-grow" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                    <form *ngIf="formGroup?.controls?.id" #theForm="ngForm" (ngSubmit)="submitForm(formGroup)" novalidate class="col-12">
                        <div [formGroup]="formGroup">
                            <div class="row mb-4">
                                <div class="col-md-4">
                                    <label class="required">Name</label>
                                </div>
                                <div class="col-md-8">
                                    <input type="text" formControlName="name" [class.is-invalid]="formGroup.get('name')?.invalid && (theForm.submitted || formGroup.get('name')?.touched)" placeholder="Type name" class="form-control" required>
                                    <div class="text-danger text-end w-100" *ngIf="formGroup.get('name')?.invalid && (theForm.submitted || formGroup.get('name')?.touched)">
                                        <small *ngIf="formGroup.get('name')?.errors?.required">Type name</small>
                                        <small *ngIf="formGroup.get('name')?.errors?.serverError">{{formGroup.get('name')?.errors?.serverError}}</small>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-md-4">
                                    <label class="required">Email</label>
                                </div>
                                <div class="col-md-8">
                                    <input type="email" formControlName="email" [class.is-invalid]="formGroup.get('email')?.invalid && (theForm.submitted || formGroup.get('email')?.touched)" placeholder="Type email" class="form-control" required>
                                    <div class="text-danger text-end w-100" *ngIf="formGroup.get('email')?.invalid && (theForm.submitted || formGroup.get('email')?.touched)">
                                        <small *ngIf="formGroup.get('email')?.errors?.required">Type email</small>
                                        <small *ngIf="formGroup.get('email')?.errors?.serverError">{{formGroup.get('email')?.errors?.serverError}}</small>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-md-4">
                                    <label>Password</label>
                                </div>
                                <div class="col-md-8">
                                    <input type="text" formControlName="password" [class.is-invalid]="formGroup.get('password')?.invalid && (theForm.submitted || formGroup.get('password')?.touched)" placeholder="Type password" class="form-control">
                                    <div>
                                        <small>Keep blank if not changed</small>
                                    </div>
                                    <div class="text-danger text-end w-100" *ngIf="formGroup.get('password')?.invalid && (theForm.submitted || formGroup.get('password')?.touched)">
                                        <small *ngIf="formGroup.get('password')?.errors?.required">Type password</small>
                                        <small *ngIf="formGroup.get('password')?.errors?.serverError">{{formGroup.get('password')?.errors?.serverError}}</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center border-top pt-4 mt-4">
                            <div>
                                &nbsp;
                            </div>
                            <div class="text-end">
                                <button type="button" class="btn btn-secondary" (click)="back();" [attr.disabled]="loading.status ? 'disabled' : null">
                                    <i class="material-icons">close</i> &nbsp;
                                    Batal
                                </button>
                                &nbsp;
                                <button type="submit" class="btn btn-primary" [attr.disabled]="loading.status ? 'disabled' : null">
                                    <i class="material-icons">save</i> &nbsp;
                                    Simpan
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
